<template>
  <v-card flat>
    <v-container>
      <div class="">
        <h3 class="earth-color">ADD REVENUE SPLIT</h3>
      </div>
      <v-form @submit.prevent="addSplitRevenueGroup()">
        <v-layout row wrap>
          <v-flex lg5 md5 sm12 xs12>
            <v-container>
              <v-text-field
                label="Account Code"
                v-model="revenue_group.account_code"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg5 md5 sm12 xs12>
            <v-container>
              <v-text-field
                label="Percent Split"
                v-model="revenue_group.account_percent"
                :rules="requiredRules"
                required
                type="number"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg2 md2 sm12 xs12>
            <v-container>
              <v-btn :depressed="true" block color="primary" type="submit"
                >Add Revenue</v-btn
              >
            </v-container>
          </v-flex>
        </v-layout>
      </v-form>
      <v-container>
        <table class="table table-bordered">
          <tr>
            <td>Account Code</td>
            <td>Account Percent</td>
          </tr>
          <tr v-for="(rev, key) in split_revenue" :key="key">
            <td>{{ rev.account_code }}</td>
            <td>{{ rev.account_percent }}</td>
         
          </tr>
        </table>
        <v-btn
          :depressed="true"
          color="error"
          type="submit"
          @click.prevent="resetRevenueSplit()"
          :loading="$loadingTrue"
          v-if=" split_revenue.length > 0"
          >Reset Split</v-btn
        >
        <v-btn
          :depressed="true"
          color="info"
          type="submit"
          @click.prevent="postRevenueSplit()"
          :loading="$loadingTrue"
          v-if="split_revenue.length > 0"
          >Post Split</v-btn
        >
      </v-container>
      <table cellpadding="1" cellspacing="1" class="table table-bordered">
        <thead>
          <tr>
            <td>Created Date</td>
            <td>Split Details</td>
            <td>Action</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(revenue, key) in facilitySplitRevenueData" :key="key">
            <td>{{ formated_date(revenue.created_at) }}</td>
            <td><p v-for="(split, key) in revenue.revenue_split_percent" :key="key" >
                  <span><b>Account Code:</b> {{ split.account_code  }} <span> <b>   Percent Split:</b> {{split.account_percent}}%</span></span>
            </p>
            </td>
              
             
            <td>
              <v-btn
                :depressed="true"
                small
                color="error"
                :loading="$loadingTrue"
                @click="disableSplit(revenue.public_id)"
                >Disable</v-btn
              >
              <v-btn
                :depressed="true"
                small
                color="warning"
                v-if="contact.status === 7"
                @click="enableContact(contact.public_id)"
                >Enable</v-btn
              >
              <v-btn
                :depressed="true"
                small
                color="error"
                v-if="contact.status === 7"
                @click="deleteContact(contact.public_id)"
                >Delete</v-btn
              >
            </td>
          </tr>
        </tbody>
      </table>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "facility-contacts",
  data() {
    return {
      requiredRules: [(v) => !!v || "This field is required"],
      contact: {
        contact_email: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
        facility_id: this.$route.params.facility_id,
      },
      revenue_group: {
        account_code: "",
        account_percent: "",
      },
      split_revenue: [],
    };
  },
  methods: {
    resetRevenueSplit: function () {
      this.split_revenue = []
    },
    resetOneRevenueSplit: function () {
      this.revenue_group = {
        account_code: "",
        account_percent: "",
      };
    },
    addSplitRevenueGroup: function () {
      let data = {
        account_code: this.revenue_group.account_code,
        account_percent: this.revenue_group.account_percent,
      };
      this.split_revenue.push(data);
      this.resetOneRevenueSplit();
    },
    

    postRevenueSplit: function () {
      let rev_split_data = {
       
        revenue_split_percent: this.split_revenue,
        facility_id:this.$route.params.facility_id,
        session_id: localStorage.getItem("lkjhgfdsa"),
      }
      this.$store.dispatch("post_revenue_split", rev_split_data)
      // this.resetRevenueSplit();
          
    },
    disableSplit: function (publicId) {
      var data = {
        public_id: publicId,
        facility_id: this.$route.params.facility_id,
        deleted_by: localStorage.getItem("lkjhgfdsa"),
      };
      this.$store.dispatch("delete_facility_split", data);
    
    },
  },
  created() {
    this.$store.dispatch(
      "get_all_revenue_split",
      this.$route.params.facility_id
    );
  },
};
</script>

<style scoped>
</style>
